"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _TextInput = _interopRequireDefault(require("../text-input/TextInput"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _uuid = require("uuid");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcSlider = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? "" : _ref$helperText,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$showLimitsValues = _ref.showLimitsValues,
      showLimitsValues = _ref$showLimitsValues === void 0 ? false : _ref$showLimitsValues,
      _ref$showInput = _ref.showInput,
      showInput = _ref$showInput === void 0 ? false : _ref$showInput,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$marks = _ref.marks,
      marks = _ref$marks === void 0 ? false : _ref$marks,
      onChange = _ref.onChange,
      onDragEnd = _ref.onDragEnd,
      labelFormatCallback = _ref.labelFormatCallback,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fillParent" : _ref$size;

  var _useState = (0, _react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : 0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      dragging = _useState4[0],
      setDragging = _useState4[1];

  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);

  var _useState5 = (0, _react.useState)("label-".concat((0, _uuid.v4)())),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 1),
      labelId = _useState6[0];

  var minLabel = (0, _react.useMemo)(function () {
    return labelFormatCallback ? labelFormatCallback(minValue) : minValue;
  }, [labelFormatCallback, minValue]);
  var maxLabel = (0, _react.useMemo)(function () {
    return labelFormatCallback ? labelFormatCallback(maxValue) : maxValue;
  }, [labelFormatCallback, maxValue]);
  var tickMarks = (0, _react.useMemo)(function () {
    var ticks = [];
    var numberOfMarks = Math.floor(maxValue / step - minValue / step);
    var index = 0;
    var range = maxValue - minValue;

    if (marks) {
      while (index <= numberOfMarks) {
        ticks.push( /*#__PURE__*/_react["default"].createElement(TickMark, {
          disabled: disabled,
          stepPosition: step * index / range,
          backgroundType: backgroundType,
          stepValue: (value !== null && value !== void 0 ? value : innerValue) / maxValue
        }));
        index++;
      }

      return ticks;
    } else {
      return null;
    }
  }, [minValue, maxValue, step, value, innerValue]);

  var handleSliderChange = function handleSliderChange(event) {
    var valueToCheck = event.target.value;
    (valueToCheck !== value || valueToCheck !== innerValue) && setInnerValue(valueToCheck);
    onChange === null || onChange === void 0 ? void 0 : onChange(valueToCheck);
  };

  var handleSliderDragging = function handleSliderDragging() {
    setDragging(true);
  };

  var handleSliderOnChangeCommited = function handleSliderOnChangeCommited(event) {
    if (dragging) {
      setDragging(false);
      onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event.target.value);
    }
  };

  var handlerInputChange = function handlerInputChange(event) {
    var intValue = parseInt(event.value, 10);

    if (value == null) {
      if (!Number.isNaN(intValue)) setInnerValue(intValue > maxValue ? maxValue : intValue);
    }

    if (!Number.isNaN(intValue)) {
      onChange === null || onChange === void 0 ? void 0 : onChange(intValue > maxValue ? maxValue : intValue);
    }
  };

  var isFirefox = navigator.userAgent.indexOf("Firefox") !== -1;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.slider
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    margin: margin,
    size: size,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(Label, {
    id: labelId,
    disabled: disabled,
    backgroundType: backgroundType
  }, label), /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled,
    backgroundType: backgroundType
  }, helperText), /*#__PURE__*/_react["default"].createElement(SliderContainer, null, showLimitsValues && /*#__PURE__*/_react["default"].createElement(MinLabelContainer, {
    backgroundType: backgroundType,
    disabled: disabled
  }, minLabel), /*#__PURE__*/_react["default"].createElement(SliderInputContainer, null, /*#__PURE__*/_react["default"].createElement(SliderInput, {
    role: "slider",
    type: "range",
    value: value != null && value >= 0 ? value : innerValue,
    min: minValue,
    max: maxValue,
    step: step,
    marks: marks,
    disabled: disabled,
    "aria-labelledby": labelId,
    "aria-orientation": "horizontal",
    "aria-valuemax": maxValue,
    "aria-valuemin": minValue,
    "aria-valuenow": value != null && value >= 0 ? value : innerValue,
    onChange: handleSliderChange,
    onMouseUp: handleSliderOnChangeCommited,
    onMouseDown: handleSliderDragging,
    backgroundType: backgroundType
  }), marks && /*#__PURE__*/_react["default"].createElement(MarksContainer, {
    isFirefox: isFirefox
  }, tickMarks)), showLimitsValues && /*#__PURE__*/_react["default"].createElement(MaxLabelContainer, {
    backgroundType: backgroundType,
    disabled: disabled,
    step: step
  }, maxLabel), showInput && /*#__PURE__*/_react["default"].createElement(StyledTextInput, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    name: name,
    value: value != null && value >= 0 ? value.toString() : innerValue.toString(),
    disabled: disabled,
    onChange: handlerInputChange,
    size: "fillParent"
  })))));
});

var sizes = {
  medium: "360px",
  large: "480px",
  fillParent: "100%"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var getChromeStyles = function getChromeStyles() {
  return "\n  width: 100%;\n  margin-right: 4px;";
};

var getFireFoxStyles = function getFireFoxStyles() {
  return "\n  width: calc(100% - 16px);\n  margin-right: 3px;";
};

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  width: ", ";\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return calculateWidth(props.margin, props.size);
});

var Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledLabelFontColorOnDark : props.theme.disabledLabelFontColor : props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.theme.labelFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
});

var HelperText = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledHelperTextFontColorOnDark : props.theme.disabledHelperTextFontColor : props.backgroundType === "dark" ? props.theme.helperTextFontColorOnDark : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var SliderInput = _styledComponents["default"].input(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  min-width: 240px;\n  height: ", ";\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  background-color: ", ";\n  background-image: ", ";\n  background-repeat: no-repeat;\n  background-size: ", ";\n  border-radius: 5px;\n  z-index: 1;\n  cursor: ", ";\n  &::-webkit-slider-runnable-track {\n    -webkit-appearance: none;\n    box-shadow: none;\n    border: none;\n    background: transparent;\n    margin: 0px -8px;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: none;\n    height: ", ";\n    width: ", ";\n    border-radius: 25px;\n    background: ", ";\n    &:active {\n      ", "\n    }\n    &:hover {\n      ", "\n    }\n  }\n  &::-moz-range-track {\n    -webkit-appearance: none;\n    box-shadow: none;\n    border: none;\n    background: transparent;\n  }\n  &::-moz-range-thumb {\n    -webkit-appearance: none;\n    border: none;\n    height: ", ";\n    width: ", ";\n    border-radius: 25px;\n    background: ", ";\n    &:active {\n      background: ", ";\n      transform: scale(1.16667);\n    }\n    &:hover {\n      ", "\n    }\n  }\n  &:focus {\n    outline: none;\n    &::-webkit-slider-thumb {\n      outline: ", "\n        auto 1px;\n      outline-offset: 2px;\n    }\n    &::-moz-range-thumb {\n      outline: ", "\n        auto 1px;\n      outline-offset: 2px;\n    }\n  }\n"])), function (props) {
  return props.theme.trackLineThickness;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledTotalLineColorOnDark + "61" : props.theme.disabledTotalLineColor + "61" : props.backgroundType === "dark" ? props.theme.totalLineColorOnDark + "61" : props.theme.totalLineColor;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? "linear-gradient(".concat(props.theme.disabledTrackLineColorOnDark, ", ").concat(props.theme.disabledTrackLineColorOnDark, ")") : "linear-gradient(".concat(props.theme.disabledTrackLineColor, ", ").concat(props.theme.disabledTrackLineColor, ")") : props.backgroundType === "dark" ? "linear-gradient(".concat(props.theme.trackLineColorOnDark, ", ").concat(props.theme.trackLineColorOnDark, ")") : "linear-gradient(".concat(props.theme.trackLineColor, ", ").concat(props.theme.trackLineColor, ")");
}, function (props) {
  return (props.value - props.min) * 100 / (props.max - props.min) + "% 100%";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return props.theme.thumbHeight;
}, function (props) {
  return props.theme.thumbWidth;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledThumbBackgroundColorOnDark : props.theme.disabledThumbBackgroundColor : props.backgroundType === "dark" ? props.theme.thumbBackgroundColorOnDark : props.theme.thumbBackgroundColor;
}, function (props) {
  if (!props.disabled) {
    return "\n          background: ".concat(props.backgroundType === "dark" ? props.theme.activeThumbBackgroundColorOnDark : props.theme.activeThumbBackgroundColor, ";\n            transform: scale(1.16667);");
  }
}, function (props) {
  if (!props.disabled) {
    return "height: ".concat(props.theme.hoverThumbHeight, ";\n          width: ").concat(props.theme.hoverThumbWidth, ";\n          transform: scale(1.16667);\n          transform-origin: center center;\n          background: ").concat(props.backgroundType === "dark" ? props.theme.hoverThumbBackgroundColorOnDark : props.theme.hoverThumbBackgroundColor, ";");
  }
}, function (props) {
  return props.theme.thumbHeight;
}, function (props) {
  return props.theme.thumbWidth;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledThumbBackgroundColorOnDark : props.theme.disabledThumbBackgroundColor : props.backgroundType === "dark" ? props.theme.thumbBackgroundColorOnDark : props.theme.thumbBackgroundColor;
}, function (props) {
  return props.backgroundType === "dark" ? props.theme.activeThumbBackgroundColorOnDark : props.theme.activeThumbBackgroundColor;
}, function (props) {
  if (!props.disabled) {
    return "height: ".concat(props.theme.hoverThumbHeight, ";\n          width: ").concat(props.theme.hoverThumbWidth, ";\n          transform: scale(1.16667);\n          transform-origin: center center;\n          background: ").concat(props.backgroundType === "dark" ? props.theme.hoverThumbBackgroundColorOnDark : props.theme.hoverThumbBackgroundColor, ";");
  }
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledFocusColorOnDark : props.theme.disabledFocusColor : props.backgroundType === "dark" ? props.theme.focusColorOnDark : props.theme.focusColor;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledFocusColorOnDark : props.theme.disabledFocusColor : props.backgroundType === "dark" ? props.theme.focusColorOnDark : props.theme.focusColor;
});

var SliderContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  height: 48px;\n  align-items: center;\n"])));

var LimitLabelContainer = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  white-space: nowrap;\n"])), function (props) {
  return props.disabled ? props.theme.disabledLimitValuesFontColor : props.backgroundType === "dark" ? props.theme.limitValuesFontColorOnDark : props.theme.limitValuesFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.limitValuesFontSize;
}, function (props) {
  return props.theme.limitValuesFontStyle;
}, function (props) {
  return props.theme.limitValuesFontWeight;
}, function (props) {
  return props.theme.limitValuesFontLetterSpacing;
});

var MinLabelContainer = (0, _styledComponents["default"])(LimitLabelContainer)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n"])), function (props) {
  return props.theme.floorLabelMarginRight;
});
var MaxLabelContainer = (0, _styledComponents["default"])(LimitLabelContainer)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), function (props) {
  return props.step === 1 ? props.theme.ceilLabelMarginLeft : "1.25rem";
});

var SliderInputContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  width: 100%;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: -2px;\n  padding-top: 1px;\n"])));

var MarksContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  position: absolute;\n  pointer-events: none;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"])), function (props) {
  return props.isFirefox ? getFireFoxStyles() : getChromeStyles();
});

var TickMark = _styledComponents["default"].span(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  background: ", ";\n  height: ", ";\n  width: ", ";\n  border-radius: 18px;\n  left: ", ";\n  ", ";\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledTickBackgroundColorOnDark : props.theme.disabledTickBackgroundColor : props.backgroundType === "dark" ? props.theme.tickBackgroundColorOnDark : props.theme.tickBackgroundColor;
}, function (props) {
  return props.theme.tickHeight;
}, function (props) {
  return props.theme.tickWidth;
}, function (props) {
  return "calc(".concat(props.stepPosition, " * 100%)");
}, function (props) {
  return !props.disabled ? "z-index: ".concat(props.stepPosition <= props.stepValue ? "0" : "1") : "";
});

var StyledTextInput = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n  max-width: 70px;\n"])), function (props) {
  return props.theme.inputMarginLeft;
});

var _default = DxcSlider;
exports["default"] = _default;